"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.Block = {
  name: 'Block',
  autoRoutes: ['create', 'update'],
  table: {
    fieldNames: ["title", "content"]
  },
  form: {
    modal: {
      fill: true,
      maxWidth: '1200px'
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'library'
    }, {
      name: 'colors'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'options'
    }],
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      title: {
        type: 'text'
      },
      subtitle: {
        type: 'text'
      },
      pretitle: {
        type: 'text'
      },
      titleRich: {
        type: 'longText',
        label: 'Title (Rich)',
        description: 'Provide a rich version of the title if needed. This can be useful, for example, when needing art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      subtitleRich: {
        type: 'longText',
        label: 'Subtitle (Rich)',
        description: 'Provide a rich version of the subtitle if needed. This can be useful, for example, when needing art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      layout: {
        type: 'linked',
        entityTypeName: 'BlockLayout',
        label: 'Layout',
        description: 'Select a layout for this {{BLOCK}}, if any. Layouts allow the same {{BLOCK}} to be presented with a different visual design even within the same {{SLICE_LAYOUT}}.'
      },
      content: {
        type: 'longText'
      },
      backgroundColor: {
        type: 'linked',
        entityTypeName: 'Color',
        fieldSet: 'colors',
        label: 'Background Color'
      },
      color: {
        type: 'linked',
        entityTypeName: 'Color',
        fieldSet: 'colors'
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon',
        fieldSet: 'library'
      },
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      image: {
        type: 'linked',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      options: {
        type: 'json',
        description: "Add extra options in JSON format. Note: this is intended as a hook for developers to be able to change advanced properties not available in the standard content fields.",
        fieldSet: 'admin'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      }
    })
  }
};